import { render, staticRenderFns } from "./RangeTable.vue?vue&type=template&id=3381ec20&"
import script from "./RangeTable.vue?vue&type=script&lang=js&"
export * from "./RangeTable.vue?vue&type=script&lang=js&"
import style0 from "./RangeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports